import React, { useEffect, useState } from "react";
import { onAuthStateChanged, signOut } from "firebase/auth";
import { auth } from "../firebase";
import logo from "../assets/logo.png";
import AuthRequiredModal from "./AuthRequiredModal";
import { useNavigate } from "react-router-dom";

const Navbar = ({ setCurrentPage }) => {
  const [isAuthed, setIsAuthed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [showAuthModal, setShowAuthModal] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (user) => {
      setIsAuthed(!!user);
    });
    return () => unsub();
  }, []);

  const handleLogout = async () => {
    const ok = window.confirm("Çıkış yapmak istediğinizden emin misiniz?");
    if (!ok) return;
    try {
      await signOut(auth);
      setCurrentPage("home");
    } catch (e) {
      console.error(e);
      alert("Çıkış yapılırken bir sorun oluştu.");
    }
  };

  const go = (page) => {
    setCurrentPage(page);
    navigate("/");
    setMobileOpen(false);
  };

  const Menu = ({ mobile = false }) => (
    <div
      className={`${
        mobile ? "flex flex-col w-full" : "flex items-center gap-6"
      }`}
    >
      <NavItem
        title="ANASAYFA"
        subtitle="firma rehberi anasayfanız"
        onClick={() => go("home")}
        mobile={mobile}
      />
      <NavItem
        title="FİRMALAR"
        subtitle="yüzlerce kayıtlı firma"
        onClick={() => go("firms")}
        mobile={mobile}
      />
      <NavItem
        title="ÜNLÜLER / SİYASİLER"
        subtitle="ünlü ve siyasilerimiz"
        onClick={() => go("unlulerSivas")}
        mobile={mobile}
      />
      <NavItem
        title="HAKKIMIZDA"
        subtitle="biz kimiz, ne yapıyoruz"
        onClick={() => go("hakkimizda")}
        mobile={mobile}
      />
    </div>
  );

  const AuthButtons = ({ mobile = false }) => (
    <div
      className={`${
        mobile ? "flex flex-col gap-2 w-full" : "flex items-center gap-3"
      }`}
    >
      {!isAuthed ? (
        <>
          <button
            onClick={() => go("login")}
            className={`${
              mobile ? "w-full" : ""
            } bg-white text-amber-600 px-4 py-2 rounded-lg font-semibold hover:bg-gray-100 transition`}
          >
            Giriş Yap
          </button>
          <button
            onClick={() => go("register")}
            className={`${
              mobile ? "w-full" : ""
            } bg-amber-600 text-white px-4 py-2 rounded-lg font-semibold hover:bg-amber-700 transition`}
          >
            Üye Ol
          </button>
          <button
            onClick={() => {
              if (!isAuthed) {
                setShowAuthModal(true);
              } else {
                go("firmAdd");
              }
            }}
            className={`${
              mobile ? "w-full" : ""
            } bg-slate-800 text-white px-4 py-2 rounded-lg font-semibold hover:bg-slate-900 transition`}
            aria-label="Firma Ekle"
            title="Firma Ekle"
          >
            Firma Ekle
          </button>
        </>
      ) : (
        <>
          <button
            onClick={() => {
              if (!isAuthed) {
                setShowAuthModal(true);
              } else {
                go("firmAdd");
              }
            }}
            className={`${
              mobile ? "w-full" : ""
            } bg-slate-800 text-white px-4 py-2 rounded-lg font-semibold hover:bg-slate-900 transition`}
            aria-label="Firma Ekle"
            title="Firma Ekle"
          >
            Firma Ekle
          </button>
          <button
            onClick={handleLogout}
            className={`${
              mobile ? "w-full" : ""
            } bg-white text-slate-800 px-4 py-2 rounded-lg font-semibold border hover:bg-gray-50 transition`}
            aria-label="Çıkış Yap"
            title="Çıkış Yap"
          >
            Çıkış Yap
          </button>
        </>
      )}
    </div>
  );

  return (
    <>
      {showAuthModal && (
        <AuthRequiredModal
          onClose={() => setShowAuthModal(false)}
          onLogin={() => {
            setShowAuthModal(false);
            go("login");
          }}
          onRegister={() => {
            setShowAuthModal(false);
            go("register");
          }}
        />
      )}
      <nav className="bg-amber-400 shadow-md sticky top-0 z-40">
        <div className="max-w-7xl mx-auto px-2 md:px-4">
          {/* Üst Satır */}
          <div className="flex items-center justify-between py-3">
            {/* Sol: Logo + Masaüstü Menü */}
            <div className="flex items-center">
              <button
                onClick={() => go("home")}
                className="mr-3 md:mr-6 flex items-center"
                aria-label="İşteSivas Anasayfa"
              >
                <img
                  src={logo}
                  alt="İşte Sivas Logo"
                  className="h-12 w-auto object-contain"
                />
              </button>

              {/* Desktop menu */}
              <div className="hidden md:block">
                <Menu />
              </div>
            </div>

            {/* Sağ: Auth (desktop) */}
            <div className="hidden md:flex">
              <AuthButtons />
            </div>

            {/* Mobile hamburger */}
            <div className="md:hidden flex items-center gap-2">
              <button
                onClick={() => {
                  if (!isAuthed) {
                    setShowAuthModal(true);
                  } else {
                    go("firmAdd");
                  }
                }}
                className="bg-slate-800 text-white px-3 py-1.5 rounded-lg text-xs font-semibold hover:bg-slate-900 transition"
              >
                + Firma Ekle
              </button>

              <button
                className="inline-flex items-center justify-center w-10 h-10 rounded-lg hover:bg-amber-300/60 transition"
                onClick={() => setMobileOpen((s) => !s)}
                aria-label="Menüyü aç/kapat"
              >
                <div className="space-y-1.5">
                  <span className="block w-6 h-0.5 bg-gray-900" />
                  <span className="block w-6 h-0.5 bg-gray-900" />
                  <span className="block w-6 h-0.5 bg-gray-900" />
                </div>
              </button>
            </div>
          </div>

          {/* Mobile dropdown */}
          {mobileOpen && (
            <div className="md:hidden pb-3 border-t border-amber-300">
              <div className="pt-3">
                {/* Menü kalemleri: tam genişlik, hizalı, eşit padding */}
                <div className="flex flex-col w-full">
                  <Menu mobile />
                </div>
                {/* Ayrım */}
                <div className="my-3 border-t border-amber-300/70" />
                {/* Auth butonları: tam genişlik */}
                <AuthButtons mobile />
              </div>
            </div>
          )}
        </div>
      </nav>
    </>
  );
};

const NavItem = ({ title, subtitle, onClick, mobile = false }) => (
  <button
    type="button"
    onClick={onClick}
    className={
      mobile
        ? // Mobil: tam genişlik, aynı padding ve hizalı görünüm
          "w-full text-left px-3 py-2 rounded-md hover:bg-amber-300/30 transition"
        : // Desktop
          "flex items-center gap-2 cursor-pointer hover:opacity-80 transition text-left"
    }
  >
    <div className={mobile ? "flex flex-col leading-tight" : ""}>
      <div className="text-xs font-bold text-gray-800">{title}</div>
      <div className="text-[11px] text-gray-700/80">{subtitle}</div>
    </div>
  </button>
);

export default Navbar;
